'use client'

import {useLocalObservable} from 'mobx-react'

import type {LoginFormState} from '@/src/features/auth/core/login-types'

export const useLoginFormState = (): LoginFormState => {
  return useLocalObservable(
    () =>
      ({
        form: 'phone',
        options: {},
        changeForm(form, options) {
          this.form = form
          this.options = options
        },
      }) as LoginFormState,
  )
}
